import ButtonToggleController from './button_toggle_controller'

export default class extends ButtonToggleController {
  static targets = ['basicAuthContent', 'ssoAuthContent', 'apiContent', 'button']

  toggleSection (event: Event): void {
    const input = event.target as HTMLInputElement
    const contentTargetName = input.dataset.toggleTarget

    if (contentTargetName == null || contentTargetName === '') {
      return
    }

    const target = (this as any)[`${contentTargetName}Target`] as HTMLElement
    target.classList.toggle('hidden', !input.checked)
    this.enabledValue = input.checked
  }
}
